import reducer from "./reducer";
export { default as PollComparison } from "./components/index";
export { default as pollComparisonReducerName } from "./constants";
export default reducer;
